import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { TreePersonCard } from '@/components/person/TreePersonCard';
import { useHybridPedigreeStore } from '@/hooks/useStores';

interface GrandparentsGenerationProps {
  onTreeViewClick?: (familyMemberId: string) => void;
  onProfileClick?: (familyMemberId: string) => void;
  onAddClick?: (familyMemberId: string, option: 'child' | 'spouse' | 'parent' | 'pet') => void;
  canAddByMemberId?: Record<string, boolean>;
}

const GrandparentsGeneration: React.FC<GrandparentsGenerationProps> = observer(
  ({ onTreeViewClick, onProfileClick, onAddClick, canAddByMemberId = {} }) => {
    const { t } = useTranslation('pedigree');
    const hybridPedigreeStore = useHybridPedigreeStore();
    const {
      leftGrandparentsLeftFamilyMemberId,
      leftGrandparentsRightFamilyMemberId,
      rightGrandparentsLeftFamilyMemberId,
      rightGrandparentsRightFamilyMemberId
    } = hybridPedigreeStore.grandparentsGen;

    return (
      <div className="generation generation-grandparents">
        <span className="generation-label" aria-hidden>
          {t('generations.grandparents')}
        </span>
        {/* Left Partnership */}
        <div className="grandparent-partnership left-partnership">
          {leftGrandparentsLeftFamilyMemberId && (
            <TreePersonCard
              familyMemberId={leftGrandparentsLeftFamilyMemberId}
              generation={-2}
              onTreeViewClick={onTreeViewClick}
              onProfileClick={onProfileClick}
              onAddClick={onAddClick}
              canAddFamilyMember={canAddByMemberId[leftGrandparentsLeftFamilyMemberId] ?? false}
              isTreeAnchor={false}
            />
          )}
          {leftGrandparentsRightFamilyMemberId && (
            <TreePersonCard
              familyMemberId={leftGrandparentsRightFamilyMemberId}
              generation={-2}
              onTreeViewClick={onTreeViewClick}
              onProfileClick={onProfileClick}
              onAddClick={onAddClick}
              canAddFamilyMember={canAddByMemberId[leftGrandparentsRightFamilyMemberId] ?? false}
              isTreeAnchor={false}
            />
          )}
        </div>

        {/* Right Partnership */}
        <div className="grandparent-partnership right-partnership">
          {rightGrandparentsLeftFamilyMemberId && (
            <TreePersonCard
              familyMemberId={rightGrandparentsLeftFamilyMemberId}
              generation={-2}
              onTreeViewClick={onTreeViewClick}
              onProfileClick={onProfileClick}
              onAddClick={onAddClick}
              canAddFamilyMember={canAddByMemberId[rightGrandparentsLeftFamilyMemberId] ?? false}
              isTreeAnchor={false}
            />
          )}
          {rightGrandparentsRightFamilyMemberId && (
            <TreePersonCard
              familyMemberId={rightGrandparentsRightFamilyMemberId}
              generation={-2}
              onTreeViewClick={onTreeViewClick}
              onProfileClick={onProfileClick}
              onAddClick={onAddClick}
              canAddFamilyMember={canAddByMemberId[rightGrandparentsRightFamilyMemberId] ?? false}
              isTreeAnchor={false}
            />
          )}
        </div>
      </div>
    );
  }
);

export default GrandparentsGeneration;
